module.exports = __webpack_public_path__ + "ki.svg?4f47a3dbd855e14cb4362e51b81ef78a";